import { Box, CardContent, Divider, Typography } from '@mui/material'
import { LoanDetails } from '@src/data/types/loanDetails'
import { CSSProperties, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TallCardStyled } from './StyledComponent'

interface TallCardProps {
  loanDetails?: LoanDetails
}

const TallCard: FC<TallCardProps> = ({ loanDetails }) => {
  const { t } = useTranslation()

  const styles: Record<string, CSSProperties> = {
    content: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px',
      fontWeight: '200',
      gap: '10px',
    },
    amount:{
      alignItems: 'center',
      
    }
    
  }
  const calculateTotalFees = () => {
    const lateAmount = loanDetails?.lateAmountWithInterest || 0;
    const nsfFees = loanDetails?.totalNSFFeesUnpaidAmount || 0;
    const otherFees = loanDetails?.totalGeneralFeesUnpaidAmount || 0;
    return lateAmount + nsfFees + otherFees;
  };
  const renderDetail = (titleKey: string, value?: number | null) => {
    const isAmountRed = value && value > 0 && (
      titleKey === 'loanStatus.lateAmount' ||
      titleKey === 'loanStatus.lateFeesDate' ||
      titleKey === 'loanStatus.unreplacedAmount' ||
      titleKey === 'loanStatus.nsfFees' ||
      titleKey === 'loanStatus.otherFees'
    );
    const amountStyle = {
      ...styles.amount,
      color: isAmountRed ? '#E6492D' : 'inherit',
    };
    if (titleKey === 'loanStatus.unreplacedAmount' && isAmountRed) {
      amountStyle.fontSize = '1.8rem ' ;
    } else {
      amountStyle.fontSize = '1.4rem';
    }
  
    const formattedValue = value?.toFixed(2) ?? '0';
    const displayValue = (
      titleKey === 'loanStatus.totalDue' || 
      titleKey === 'loanStatus.unreplacedAmount' || 
      titleKey === 'loanStatus.lateAmount' || 
      titleKey === 'loanStatus.nsfFees' ||
      titleKey === 'loanStatus.lateFeesDate' 
    ) ? `${formattedValue}$` : formattedValue;
    
    return (
      <Box style={styles.content}>
        <Typography sx={{ fontWeight: '200',  fontSize: { xs: '0.8rem',sm: '1.1rem',} }}>{t(titleKey)}</Typography>
        <Typography style={amountStyle}>{displayValue}</Typography>
      </Box>
    )
  }

  return (
    <TallCardStyled>
      <CardContent>
        {renderDetail('loanStatus.totalDue', loanDetails?.totalDue)}
        {renderDetail('loanStatus.inTransit', loanDetails?.transitAmount)}
        {renderDetail('loanStatus.lateAmount', loanDetails?.lateAmountWithInterest)}
        {renderDetail('loanStatus.nsfFees', loanDetails?.totalNSFFeesUnpaidAmount)}
        {renderDetail('loanStatus.otherFees', loanDetails?.totalGeneralFeesUnpaidAmount)}
        {renderDetail('loanStatus.lateFeesDate', calculateTotalFees())}
        <Divider />
        {renderDetail('loanStatus.unreplacedAmount', loanDetails?.notReplacedAmount)}
      </CardContent>
    </TallCardStyled>
  )
}

export default TallCard
